import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "mt-6 mb-6"
}
const _hoisted_2 = {
  key: 2,
  class: "mt-6 mb-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardProfileHeader = _resolveComponent("DashboardProfileHeader")
  const _component_ECShopAdvisory = _resolveComponent("ECShopAdvisory")
  const _component_PMAReminderNotice = _resolveComponent("PMAReminderNotice")
  const _component_router_view = _resolveComponent("router-view")
  const _component_HeroBalanceCard = _resolveComponent("HeroBalanceCard")
  const _component_DashboardMovableBlock = _resolveComponent("DashboardMovableBlock")
  const _component_AccountDetails = _resolveComponent("AccountDetails")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DashboardProfileHeader, {
      user: _ctx.user,
      rankPrimeImage: _ctx.rankPrimeImage,
      rankPrime: _ctx.rankPrime,
      currentRank: _ctx.currentRank,
      showRankImage: _ctx.showRankImage,
      showLifetimeIncome: false,
      coverPhoto: _ctx.coverPhoto
    }, null, 8, ["user", "rankPrimeImage", "rankPrime", "currentRank", "showRankImage", "coverPhoto"]),
    _createVNode(_component_ECShopAdvisory),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.aboveBlocks, (block) => {
      return (_openBlock(), _createBlock(_component_DashboardMovableBlock, {
        key: 'above-' + block.id,
        label: _ctx.blockLabel(block.id),
        "can-move-up": _ctx.canMoveUp(block.id),
        "can-move-down": _ctx.canMoveDown(block.id),
        onMoveUp: ($event: any) => (_ctx.moveUp(block.id)),
        onMoveDown: ($event: any) => (_ctx.moveDown(block.id))
      }, {
        default: _withCtx(() => [
          (block.id === 'pma')
            ? (_openBlock(), _createBlock(_component_PMAReminderNotice, { key: 0 }))
            : (block.id === 'navPage')
              ? (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
              : (block.id === 'lifetime')
                ? (_openBlock(), _createBlock("div", _hoisted_1, [
                    _createVNode(_component_HeroBalanceCard, {
                      label: "Lifetime Income",
                      amount: _ctx.lifetimeIncome,
                      currencySymbol: _ctx.lifetimeCurrency
                    }, null, 8, ["amount", "currencySymbol"])
                  ]))
                : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1032, ["label", "can-move-up", "can-move-down", "onMoveUp", "onMoveDown"]))
    }), 128)),
    _createVNode(_component_AccountDetails),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.belowBlocks, (block) => {
      return (_openBlock(), _createBlock(_component_DashboardMovableBlock, {
        key: 'below-' + block.id,
        label: _ctx.blockLabel(block.id),
        "can-move-up": _ctx.canMoveUp(block.id),
        "can-move-down": _ctx.canMoveDown(block.id),
        onMoveUp: ($event: any) => (_ctx.moveUp(block.id)),
        onMoveDown: ($event: any) => (_ctx.moveDown(block.id))
      }, {
        default: _withCtx(() => [
          (block.id === 'pma')
            ? (_openBlock(), _createBlock(_component_PMAReminderNotice, { key: 0 }))
            : (block.id === 'navPage')
              ? (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
              : (block.id === 'lifetime')
                ? (_openBlock(), _createBlock("div", _hoisted_2, [
                    _createVNode(_component_HeroBalanceCard, {
                      label: "Lifetime Income",
                      amount: _ctx.lifetimeIncome,
                      currencySymbol: _ctx.lifetimeCurrency
                    }, null, 8, ["amount", "currencySymbol"])
                  ]))
                : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1032, ["label", "can-move-up", "can-move-down", "onMoveUp", "onMoveDown"]))
    }), 128))
  ], 64))
}